import Loader from "components/common/Loader";
import Navbar from "components/common/Navbar";
import React from "react";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";

const RoutesMaster = () => {
  const { showPageLoader, showSectionLoader } = useSelector(
    (state) => state.utility
  );
  return (
    <>
      {showPageLoader && <Loader />}
      <Navbar />
      {showSectionLoader && <Loader />}
      <Outlet />
    </>
  );
};

export default RoutesMaster;
